import React from 'react';

const CloseModal = () => (
  <span className='modal--close' data-closes-modal>
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path fillRule='evenodd' clipRule='evenodd' d='M2.42744 0L10 7.57256L17.5726 0L20 2.42744L12.4274 10L20 17.5726L17.5726 20L10 12.4274L2.42744 20L0 17.5726L7.57256 10L0 2.42744L2.42744 0Z' fill='black' />
    </svg>
  </span>
);

export default CloseModal;
